// material-ui
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { BrowserView, MobileView } from 'react-device-detect';
// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { drawerWidth } from 'utils/constant';
import LogoSection from '../LogoSection';
// project imports
import MenuList from './MenuList';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, window }: any) => {
	const theme: any = useTheme();
	const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

	const drawer = (
		<>
			<Box sx={{ display: { xs: 'block', md: 'none' } }}>
				<Box sx={{ display: 'flex', p: 2, mx: 'auto' }}>
					<LogoSection />
				</Box>
			</Box>
			<BrowserView>
				<PerfectScrollbar
					component='div'
					style={{
						height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 88px)',
						paddingLeft: theme.direction !== 'rtl' ? '16px' : '0px',
						paddingRight: '16px',
					}}
				>
					<MenuList />
					{/* <MenuCard /> */}
				</PerfectScrollbar>
			</BrowserView>
			<MobileView>
				<Box sx={{ px: 2 }}>
					<MenuList />
					{/* <MenuCard /> */}
				</Box>
			</MobileView>
		</>
	);

	const container =
		window !== undefined ? () => window.document.body : undefined;

	return (
		<Box
			className='side-bar'
			component='nav'
			sx={{
				flexShrink: { md: 0 },
				width: matchUpMd ? drawerWidth : 'auto',
			}}
			aria-label='mailbox folders'
		>
			<Drawer
				container={container}
				variant={matchUpMd ? 'persistent' : 'temporary'}
				anchor={theme.direction === 'rtl' ? 'right' : 'left'}
				PaperProps={{
					style: {
						transform: 'translateX(260px) !important',
					},
				}}
				open={drawerOpen}
				onClose={drawerToggle}
				sx={{
					'& .MuiDrawer-paper': {
						width: drawerWidth,
						background: theme.palette.background.default,
						color: theme.palette.text.primary,
						borderLeft: 'none',
						borderRight: '1px solid',
						borderColor: theme.palette.grey[200],
						transform:
							theme.direction === 'rtl'
								? !drawerOpen
									? 'translateX(260px) !important'
									: 'translateX(0px) !important'
								: 'none',
						[theme.breakpoints.up('md')]: {
							top: 84,
						},
					},
				}}
				ModalProps={{ keepMounted: true }}
				color='inherit'
			>
				{drawer}
			</Drawer>
		</Box>
	);
};

export default Sidebar;
